import HttpRequest from "@api/httpRequest";
import {RequestData} from "@models/axios";
import getPropByString from "@utils/get";
import {Method} from "../models/axios";

const getUrl = (): string => {
  return `/video-files`
};


function api() {
  return {
    getList: (data: RequestData) => {
      const {params = {}} = data;
      return HttpRequest.get(getUrl(), {
        params: params
      });
    },
    
    getItem: (data: RequestData) => {
      const url = `${getUrl()}/${getPropByString(data, "params.id")}`;
      return HttpRequest.get(url);
    },
    
    create: (data: RequestData) => {
      return HttpRequest.post(getUrl(), data.payload, {});
    },
    
    update: (data: RequestData) => {
      const url = `${getUrl()}/${getPropByString(data, "params.id")}`;
      const method = data.patch ? Method.PATCH : Method.PUT;
      return HttpRequest[method](url, data.payload, {});
    },
    
    delete: (data: RequestData) => {
      const url = `${getUrl()}/${getPropByString(data, "params.id")}`;
      return HttpRequest.delete(url, {});
    },
    
    validatePath: (data: RequestData) => {
      const url = `https://filmnet-api-internal-nightly.scratnet.com/transcoding`;
      return HttpRequest.get(url, {
        params : {
          path
        }
      });
    },
    
  };
}

export default api();
